import { combineReducers } from 'redux';
import { themeReducer } from './themeReducer';
import { menuReducer } from './menuReducer';
import { langReducer } from './langReducer';

const rootReducer = combineReducers({
    theme: themeReducer,
    menu: menuReducer,
    lang: langReducer
})

export default rootReducer;